const state = {
    link: null,
    text: ''
}

const actions = {
    setupHeader({ commit }, text) {
        commit('setupHeader', text);
    }
}

const mutations = {
    setupHeader(state, text) {
        state.link = null;
        state.text = text;
    },
}

export const header = {
    namespaced: true,
    state,
    actions,
    mutations
};
